import { render, staticRenderFns } from "./SiteArticleStrategyItem.vue?vue&type=template&id=55636596&"
import script from "./SiteArticleStrategyItem.vue?vue&type=script&lang=js&"
export * from "./SiteArticleStrategyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports